const TOKEN_KEY = 'acamp_token'
const ADMIN_KEY = 'acamp_admin'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
}
export function getAdmin() {
  const raw = localStorage.getItem(ADMIN_KEY)
  try { return raw ? JSON.parse(raw) : null } catch { return null }
}
export function setAdmin(admin) {
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin))
}
export function clearAdmin() {
  localStorage.removeItem(ADMIN_KEY)
}
export function isAuthenticated() {
  return !!getToken()
}
